import { ChevronLeft } from "lucide-react";

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export default function ModalBackButton({ onClick, disabled = false }: Props) {
  return (
    <button
      className={`p-1 transition-colors absolute top-4 left-4 rounded-lg ${
        disabled
          ? "text-[--color-text-primary] opacity-40 cursor-not-allowed"
          : "text-[--color-text-primary] hover:bg-[--color-background-secondary]"
      }`}
      onClick={disabled ? undefined : () => onClick()}
      disabled={disabled}
    >
      <ChevronLeft className="h-5 w-5" />
    </button>
  );
}
